import { Link } from 'react-router-dom';
import ReportsPatientList from '../../components/patient/ReportspatientList';
import { SubtleButton } from '@repo/ui';

const Patient = () => {
    return (
        <div className="mt-6 w-full">
            <div className='flex justify-between '>
                <h1 className="text-2xl font-bold text-primery-blue-800 mb-2">تقارير المرضى</h1>

                <Link to="/reports" className="mb-6 inline-block">
                    <SubtleButton>عودة لقائمة التقارير</SubtleButton>
                </Link>
            </div>
            <ReportsPatientList />
        </div>
    );
};

export default Patient;
